import { IAllPermission } from "@/store/PermissionStore";

export function getPermissionIds(
  permissionList: IAllPermission[],
  res: number[] = [],
  deep: number = 0
): number[] {
  return permissionList
    .map((item) => {
      if (!item.children || item.children.length === 0) return [item.id];
      return res.concat([
        item.id,
        ...getPermissionIds(item.children, res, ++deep),
      ]);
    })
    .flat();
}
